import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import api from "../../services/Api";

/*
 * MYYNTIKEHOTE (Mika 3.11.2026): sama kulmakortti kuin BidMyTimesharessa (SellNudge.tsx):
 * "Myytkö lomaosakettasi?" + Jätä ilmoitus -nappi, joka tärisee välillä. Ei koko ruudun
 * ponnahdusikkuna: mikään ei saa estää kävijää, ja Google laskee hakutuloksesta tulleen sivun
 * sijoitusta, jos sisällön päälle avautuu peittävä ikkuna. Suljettuna poissa 3 vrk.
 *
 * KENELLE (Mikan hyväksymä suunnitelma 3.11.2026). Google ei kerro sivustolle hakusanaa,
 * joten myyjä tunnistetaan saapumissivusta ja käytöksestä:
 *   Taso 1, myyjän sivut (ohjeet, myymistä ja arvoa käsittelevät artikkelit): aina 6 s jälkeen.
 *   Taso 2, ilmoituslistat, ilmoitukset ja muut sivut: vain jos kävijä tuli hakukoneesta
 *     suoraan tälle sivulle, on ollut sivulla 20 s tai vierittänyt puoleenväliin, eikä hänestä
 *     ole ostajan merkkejä (toinen ilmoitus avattu, hakusuodattimet, suosikki, tarjous).
 *   Ei koskaan: etusivu (eri asettelu, ei tätä komponenttia), PIILOTA-sivut, kirjautunut
 *     käyttäjä (hänellä on jo ilmoitus tai tarjous) ja kävijä, joka on toiminut ostajana.
 *
 * Mittaus: näyttö kirjataan nginx-lokiin (favicon-16x16.png?kehote=naytto), klikkaus
 * (?lahde=kehote) ja luonnostilin luonti (POST /api/luonnos/aloita?lahde=kehote).
 */

/* Ei koskaan (Mika 3.11.2026: "ei kauppakirja ja vuokrasopimuksen luonti sivulle, ja mieti
   kaikki sivut mihin se ei sovi"): kauppakirjan ja vuokrasopimuksen teko (/kauppakirjapalvelu
   ja /oma-sivu/sopimus), oma sivu ja hallinta, kirjautuminen, vahvistus ja salasanan vaihto,
   maksut ja niiden paluusivut, jälleenmyyntitilaus (/tarjous), näkyvyyden ostosivu (oma
   myyntisivunsa) ja yhteydenottolomake (kortti peittäisi puhelimessa lähetysnapin). */
const PIILOTA = /^\/(kirjaudu|404|tarjous|vahvista|vaihda-salasana|kauppakirjapalvelu|maksu|auth|oma-sivu|hallinta|nakyvyys|yhteystiedot)(\/|$)/;
const MYYJAN_SIVUT = new RegExp(
    "^/(ehdot-ja-ohjeet(/.*)?|artikkelit/(lomaosakkeen-myynti-nain-myyt-viikko-osakkeesi|lomaosakkeen-vuokraus-nain-saat-viikkosi-vuokralle" +
        "|mista-lomaosakkeen-hinta-muodostuu|kohteesi-sijaitsee-ulkomailla-nain-tavoitat-kansainvaliset-ostajat" +
        "|yksityiset-lomaosakkeen-omistajat-ovat-loytaneet-lomahuuto-fi-palvelun|lomahuuto-fi-vai-huutokaupat-com-kumpi-on-parempi-viikko-osakkeen-myynnissa" +
        "|lomaosakkeiden-jalleenmyynti-uusi-tehokas-tapa-myyda-lomaosake|lomaosakkeiden-jalleenmyynti-nain-saat-osakkeesi-kaupaksi" +
        "|jalleenmyynnin-ennakkomaksut))/?$"
);
const HAKUKONE = /(^|\.)(google|bing|duckduckgo|yahoo|ecosia|yandex|startpage|qwant)\./i;
const SULJETTU_AVAIN = "lh_myyntikehote_suljettu";
const SULJETTU_MS = 3 * 86400000;
const VIIVE_MS = 6000;
const TASO2_VIIVE_MS = 20000;

function lue(varasto, avain) {
    try {
        return window[varasto].getItem(avain);
    } catch (e) {
        return null;
    }
}
function kirjoita(varasto, avain, arvo) {
    try {
        window[varasto].setItem(avain, arvo);
    } catch (e) {}
}

function suljettuHiljattain() {
    const v = Number(lue("localStorage", SULJETTU_AVAIN));
    return Number.isFinite(v) && v > 0 && Date.now() - v < SULJETTU_MS;
}

/* Istunnon saapumissivu kirjataan kerran, kun sovellus latautuu (moduulin lataus = ensimmäinen
   sivu). SPA:ssa document.referrer pysyy samana koko istunnon, joten etusivulta Googlesta tullut
   ei saa näyttää hakukoneesta ilmoitussivulle tulleelta. */
const SAAPUMINEN = (() => {
    const vanha = lue("sessionStorage", "lh_saapuminen");
    if (vanha) {
        try {
            return JSON.parse(vanha);
        } catch (e) {}
    }
    let hakukoneesta = false;
    try {
        hakukoneesta = !!document.referrer && HAKUKONE.test(new URL(document.referrer).hostname);
    } catch (e) {}
    const s = { polku: window.location.pathname, haku: window.location.search, hakukoneesta };
    kirjoita("sessionStorage", "lh_saapuminen", JSON.stringify(s));
    return s;
})();

const onOstaja = () => lue("sessionStorage", "lh_ostaja") === "1";
const merkitseOstaja = () => {
    kirjoita("sessionStorage", "lh_ostaja", "1");
    window.dispatchEvent(new Event("lh-ostaja"));
};

function kirjaaNaytto(taso, polku) {
    try {
        new Image().src = "/favicon-16x16.png?kehote=naytto&taso=" + taso + "&sivu=" + encodeURIComponent(polku) + "&t=" + Date.now();
    } catch (e) {}
}

const MyyntiKehote = () => {
    const { isAuthenticated, login } = useContext(AuthContext);
    const navigate = useNavigate();
    const { pathname, search } = useLocation();
    const [nakyy, setNakyy] = useState(false);
    const polku = pathname || "/";
    const piilossa = PIILOTA.test(polku) || polku === "/" || isAuthenticated;
    const taso = MYYJAN_SIVUT.test(polku) ? 1 : 2;

    /* Ostajan merkit koko istunnolta: toinen avattu ilmoitus ja hakusuodattimet (osoitteen
       hakuosa muuttuu saapumissivulla). */
    useEffect(() => {
        const s = SAAPUMINEN;
        if (/^\/kohde\//.test(polku)) {
            const nahdyt = new Set(JSON.parse(lue("sessionStorage", "lh_nahdyt_kohteet") || "[]"));
            nahdyt.add(polku.split("/").slice(0, 3).join("/"));
            kirjoita("sessionStorage", "lh_nahdyt_kohteet", JSON.stringify([...nahdyt]));
            if (nahdyt.size >= 2) merkitseOstaja();
        }
        if (s.polku === polku && (s.haku || "") !== (search || "")) merkitseOstaja();
    }, [polku, search]);

    /* Ostajan merkit sivulla: suosikki, tarjouslomake ja hakusuodattimet. */
    useEffect(() => {
        const klikki = (e) => {
            const t = e.target;
            if (!t || !t.closest || t.closest(".lh-kehote")) return;
            if (t.closest('[title="Lisää suosikkeihin"],[title="Poista suosikeista"],.anticon-heart')) return merkitseOstaja();
            const lomake = t.closest("form");
            if (lomake && /tarjou/i.test(lomake.textContent || "")) return merkitseOstaja();
            const nappi = t.closest("button,a");
            if (nappi && /tee tarjous|tarjoa/i.test(nappi.textContent || "")) return merkitseOstaja();
            if (t.closest(".ant-select,.ant-picker,.ant-slider,.ant-checkbox-wrapper,.ant-radio-wrapper")) return merkitseOstaja();
        };
        document.addEventListener("click", klikki, true);
        const ostaja = () => setNakyy(false);
        window.addEventListener("lh-ostaja", ostaja);
        return () => {
            document.removeEventListener("click", klikki, true);
            window.removeEventListener("lh-ostaja", ostaja);
        };
    }, []);

    useEffect(() => {
        setNakyy(false);
        if (piilossa || suljettuHiljattain() || onOstaja()) return;
        const s = SAAPUMINEN;
        if (taso === 2 && !(s.hakukoneesta && s.polku === polku)) return;

        let ajastin;
        let vieritys;
        const nayta = () => {
            if (onOstaja() || suljettuHiljattain()) return;
            setNakyy(true);
            kirjaaNaytto(taso, polku);
            if (vieritys) window.removeEventListener("scroll", vieritys);
            clearTimeout(ajastin);
        };
        if (taso === 1) {
            ajastin = setTimeout(nayta, VIIVE_MS);
        } else {
            const alku = Date.now();
            ajastin = setTimeout(nayta, TASO2_VIIVE_MS);
            vieritys = () => {
                const korkeus = document.documentElement.scrollHeight - window.innerHeight;
                if (korkeus > 0 && window.scrollY / korkeus >= 0.5 && Date.now() - alku >= VIIVE_MS) nayta();
            };
            window.addEventListener("scroll", vieritys, { passive: true });
        }
        return () => {
            clearTimeout(ajastin);
            if (vieritys) window.removeEventListener("scroll", vieritys);
        };
    }, [polku, piilossa, taso]); // eslint-disable-line react-hooks/exhaustive-deps

    if (piilossa || !nakyy) return null;

    const sulje = () => {
        kirjoita("localStorage", SULJETTU_AVAIN, String(Date.now()));
        setNakyy(false);
    };

    const kohde = "/kirjaudu?lahde=kehote";
    /* Luonnostili: sama aloitus kuin Headerissa ja Herossa, merkittynä kehotteen kautta tulleeksi. */
    const aloitaMyynti = async (e) => {
        e.preventDefault();
        try {
            const vastaus = await api.aloitaLuonnos("kehote");
            await login(vastaus.token);
            navigate("/oma-sivu/ilmoitukset/uusi");
        } catch (err) {
            navigate("/kirjaudu");
        }
    };

    return (
        <div
            role="complementary"
            aria-label="Myy lomaosakkeesi"
            className="lh-kehote fixed z-40 left-3 right-3 bottom-[80px] sm:right-auto sm:bottom-5 sm:left-5 sm:w-[340px] bg-white rounded-2xl border-2 border-primary shadow-[0_10px_40px_rgba(1,105,110,0.35)] py-2 pl-3 pr-9 sm:p-4 sm:pr-10"
        >
            <style>{`
                @keyframes lhKehoteSisaan { from { transform: translateY(120%); opacity: 0 } to { transform: translateY(0); opacity: 1 } }
                @keyframes lhKehoteTarina { 0%,12%,100% { transform: rotate(0) } 2% { transform: rotate(-3deg) } 4% { transform: rotate(3deg) } 6% { transform: rotate(-2.5deg) } 8% { transform: rotate(2deg) } 10% { transform: rotate(-1deg) } }
                .lh-kehote { animation: lhKehoteSisaan .5s ease-out, lhKehoteTarina 7s ease-in-out 1.2s infinite; transform-origin: 50% 100% }
                @media (prefers-reduced-motion: reduce) { .lh-kehote { animation: none } }
            `}</style>
            <button
                type="button"
                onClick={sulje}
                aria-label="Sulje"
                className="absolute top-1/2 -translate-y-1/2 sm:translate-y-0 sm:top-2 right-1 sm:right-2 w-8 h-8 rounded-full text-gray-400 hover:text-gray-700 hover:bg-gray-100 flex items-center justify-center text-xl leading-none border-0 bg-transparent cursor-pointer"
            >
                ×
            </button>
            <div className="flex items-center gap-3 sm:block">
                <div className="flex-1 min-w-0">
                    <p className="m-0 font-bold text-gray-900 text-[14px] sm:text-lg leading-tight sm:leading-snug">
                        {taso === 1 ? "Myytkö lomaosakettasi?" : "Omistatko itse lomaosakkeen?"}
                    </p>
                    <p className="m-0 hidden sm:block text-sm text-gray-600 mt-1 leading-snug">
                        {taso === 1 ? "Ilmoitus on valmis muutamassa minuutissa." : "Jätä oma ilmoitus muutamassa minuutissa."}
                    </p>
                </div>
                <Link
                    to={kohde}
                    onClick={aloitaMyynti}
                    className="shrink-0 sm:mt-3 inline-block bg-primary hover:bg-primary-400 text-white hover:text-white font-bold px-3.5 sm:px-6 py-1.5 sm:py-2.5 rounded-xl text-[13px] sm:text-sm shadow whitespace-nowrap"
                >
                    Jätä ilmoitus →
                </Link>
            </div>
        </div>
    );
};

export default MyyntiKehote;
